export default class Api {
  createOrder(formData) {
    const headers = {
      method: 'POST',
      body: formData,
      headers: {},
    };

    if (process.env.NODE_ENV !== 'dev') {
      headers.credentials = 'include';
    }

    if (process.env.NODE_ENV === 'dev') {
      return new Promise((resolve, reject) => {
        const res = new Response('{"type":"buy","status":"success","data":{"order-id":3594502,"url":null,"payment":{"provider":"sberbank","methods":{"card":{"name":"Банковская карта","merchant_id":"otrada.comfortkino"},"apple":{"name":"Apple Pay","merchant_id":"merchant.ru.sberbank.applepay.ru.comfortkino.all"},"google":{"name":"Google Pay","merchant_id":"09651621937514946273","bank_merchant_id":"otrada.comfortkino","environment":"PRODUCTION"},"sbp":{"name":"СБП","merchant_id":"sbp_vtb_msk_otrada"}}},"expire_date_unix":1707401406,"user-id":"1041337"},"errors":[]}')

        resolve(res);
      });
    }

    return this.request(
      '/local/php_interface/api/v2/payment/create_order/',
      headers,
    ).then(response => response);
  }

  request(url, headers) {
    return fetch(url, headers);
  }
}
